import { render, staticRenderFns } from "./receivable.vue?vue&type=template&id=e27766fa&scoped=true&"
import script from "./receivable.vue?vue&type=script&lang=js&"
export * from "./receivable.vue?vue&type=script&lang=js&"
import style0 from "./receivable.vue?vue&type=style&index=0&id=e27766fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27766fa",
  null
  
)

export default component.exports